export default __webpack_public_path__ + "assets/images/f8d2ed0eb1b373d2df0b8591597db33a.svg";